import React, { useState } from 'react';
import {
  StyledAvatar,
  StyledToolbar,
  StyledAppBar,
  StyledAvatarContainer,
  StyledHeader,
  StyledGoBackButton,
  StyledIconHeadingContainer,
  StyledHeaderTitle,
  StyledSidebarToggleIcon,
  StyledHeading,
  StyledHeadingWrapper,
  StyledIcon,
  ListItem,
  ListIcon,
  ListText,
  StyledLine,
  StyledRow,
  StyledImage,
} from './styles';
import { greyScaleColour } from '@tphglobal/common/theme/style.palette';
import messages from '../messages';
import moment from 'moment';
import { Popover } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { FixedTitle } from '@tphglobal/common/utils/theme';

interface HeaderCustomProps {
  showGoBack?: boolean;
  heading?: string;
  sidebarOpen: boolean;
  setSidebarOpen: (sidebarOpen: boolean) => void;
  handleLogout: () => void;
  profileImage?: string;
  userProfile?: any;
  profileActionsItems?: Array<{
    id: string;
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
  }>;
}

const Header: React.FC<HeaderCustomProps> = ({
  showGoBack,
  heading,
  sidebarOpen,
  setSidebarOpen,
  handleLogout,
  profileImage,
  userProfile,
  profileActionsItems,
  ...props
}) => {
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const defaultProfileActionsItems = [
    {
      id: 'logout',
      icon: <LogoutIcon color='warning' />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];
  const actionsItems = profileActionsItems?.length
    ? profileActionsItems.concat(defaultProfileActionsItems)
    : defaultProfileActionsItems;

  return (
    <>
      <StyledHeader {...props}>
        <StyledAppBar>
          <StyledToolbar>
            <StyledGoBackButton>
              <StyledSidebarToggleIcon
                src={
                  sidebarOpen
                    ? '../../../assets/images/arrowOpenIcon.svg'
                    : '../../../assets/images/arrowIcon.svg'
                }
                alt='arrow'
                position='absolute'
                right='-11px'
                top='96px'
                onClick={toggleSidebar}
              />
              <StyledHeadingWrapper>
                <StyledRow>
                  <FixedTitle
                    varient='Fixed16Medium'
                    color={greyScaleColour?.white100}
                  >
                    Welcome {userProfile?.FirstName}
                  </FixedTitle>
                  <StyledImage src='../../../assets/images/wavingHand.svg' />
                </StyledRow>
                <FixedTitle
                  varient='Fixed12Medium'
                  color={greyScaleColour?.grey70}
                >
                  {messages?.header?.lastLogin}
                  {moment().format('MMMM D, YYYY')}
                </FixedTitle>
              </StyledHeadingWrapper>
            </StyledGoBackButton>
            <StyledAvatarContainer
              onClick={(e: any) => {
                handleClick(e);
              }}
            >
              {profileImage ? (
                <StyledAvatar src={profileImage} />
              ) : (
                <StyledAvatar src='../../../assets/images/defaultProfile.png' />
              )}
              <StyledIcon src='../../../assets/images/downArrowIcon.svg' />
            </StyledAvatarContainer>
          </StyledToolbar>
        </StyledAppBar>
      </StyledHeader>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{ padding: '16px' }}
      >
        {actionsItems?.map((obj: any, index) => {
          const first = index === 0;
          const last = index === actionsItems?.length - 1;
          let itemStyles;
          if (actionsItems?.length === 1) {
            itemStyles = {
              padding: '0 23px 0 0',
            };
          } else if (first) {
            itemStyles = {
              padding: '0 23px 12px 0',
            };
          } else if (last) {
            itemStyles = {
              padding: '12px 23px 0 0',
            };
          } else {
            itemStyles = {
              padding: '12px 0',
            };
          }
          return (
            <>
              <ListItem onClick={obj?.onClick} key={obj?.id} style={itemStyles}>
                <ListIcon>{obj?.icon}</ListIcon>
                <ListText>{obj?.label}</ListText>
              </ListItem>
              {index != actionsItems?.length - 1 && <StyledLine />}
            </>
          );
        })}
      </Popover>
    </>
  );
};

export default Header;
